import Pill from '@pelckmans/elementis/components/pill';
import { useTranslation } from 'react-i18next';

function MaterialPills({
  isShared,
  isAssignment,
  isStudent,
  isTeacher,
  size,
  isAdaptive,
  isOnTheFly,
  isInReview,
}: {
  isShared?: boolean;
  isAssignment?: boolean;
  isStudent?: boolean;
  isTeacher?: boolean;
  size?: 'sm' | 'md' | 'lg';
  isAdaptive?: boolean;
  isOnTheFly?: boolean;
  isInReview?: boolean;
}) {
  const { t } = useTranslation();
  const isStatePill = isAssignment || isShared;

  return (
    <>
      {isAssignment && (
        <Pill size={size} key="assignment-pill" prominence="danger">
          {t('PAGES.TOC_LEVEL.MATERIAL_PILLS.ASSIGNMENT')}
        </Pill>
      )}
      {isShared && (
        <Pill size={size} key="shared-pill" prominence="info">
          {t('PAGES.TOC_LEVEL.MATERIAL_PILLS.SHARED')}
        </Pill>
      )}
      {isStudent && !isStatePill && (
        <Pill size={size} key="student-pill">
          {t('PAGES.TOC_LEVEL.MATERIAL_PILLS.STUDENT')}
        </Pill>
      )}
      {isTeacher && !isStatePill && (
        <Pill size={size} key="teacher-pill">
          {t('PAGES.TOC_LEVEL.MATERIAL_PILLS.TEACHER')}
        </Pill>
      )}
      {isAdaptive && (
        <Pill size={size} key="adaptive-pill">
          {t('PAGES.TOC_LEVEL.MATERIAL_PILLS.IS_ADAPTIVE')}
        </Pill>
      )}
      {isOnTheFly && (
        <Pill size={size} key="on-the-fly-pill">
          {t('PAGES.TOC_LEVEL.MATERIAL_PILLS.IS_ON_THE_FLY')}
        </Pill>
      )}
      {isInReview && (
        <Pill size={size} key="in-review-pill" prominence="danger">
          {t('PAGES.TOC_LEVEL.MATERIAL_PILLS.IN_REVIEW')}
        </Pill>
      )}
    </>
  );
}

export default MaterialPills;
